define(function(require) {
    var DomUtil = require("cartovista").DomUtil;
    return {
        ID: "Freq_REG_ADM_1_3",
        THEMESETS_IDS: ["Freq_REG_ADM_1"],
        SOURCE: '<span style="margin-top:15px; float:right; font-size:10px;">Source : MEQ, SIP, DGPP, DGVI, DIS, Taux de diplomation et qualification par cohorte au secondaire - édition 2026.</span>',
        BOTTOM_PANEL: {
            PRINT_OPTIONS: {"landscape": true, "scale": 0.5},
            DEFAULTS: {
                ACTIVE_LAYER_ID: "GEO09E06_REG_ADM_GEN",
                GRAPH_TYPE: "line",
                GRAPH_DATA_ORIENTATION: "rows",
                PADDING: {"left": 30, "top": 0, "right": 15, "bottom": 30},
                HEIGHT_FN: function() {
                    if (!DomUtil.isResponsiveUI()) return $(".cv-left-bottom-pane").height() - 80;
                    else return 315;
                },
                WIDTH_FN: function() {
                    if (!DomUtil.isResponsiveUI()) return $(".cv-left-bottom-pane").width() - 40;
                    else return $("#cv-responsiveBbGraphsBottom").width() - 10;
                },
                X_DATA_NAMES: ["1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017"],
                X_AXIS_LABEL: {"text": "Cohortes", "position": "outer-right"},
                Y_AXIS_LABEL: "%",
                DATA_COLORS: {"Réseau public": "#666666"},
                DATA_CLASSES: {"Réseau public": "BbGraphs_dashed_line"},
                TOOLTIP_TITLE_FN: function(x, graph) { return "Cohorte de " + graph.categories()[x] + "-" + (parseInt(graph.categories()[x])+1); }
                //TOOLTIP_VALUE_FN: function(y, graph) { return y + "%";}
            },
            TABS: [
                {
                    BUTTON_TITLE: "Sexes réunis",
                    GRAPHS: [
                        {
                            TITLE: "Évolution des taux de diplomation et qualification par cohorte au secondaire après 5 ans, sexes réunis, cohortes de 1998 à 2017",
                            DATA_NAMES: {"Réseau public": "Moyenne provinciale - sexe réunis"},
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "GEO09E06_REG_ADM_GEN",
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_5_T_1998", "TX_5_T_1999", "TX_5_T_2000", "TX_5_T_2001", "TX_5_T_2002", "TX_5_T_2003", "TX_5_T_2004", "TX_5_T_2005", "TX_5_T_2006", "TX_5_T_2007", "TX_5_T_2008", "TX_5_T_2009", "TX_5_T_2010", "TX_5_T_2011", "TX_5_T_2012", "TX_5_T_2013", "TX_5_T_2014", "TX_5_T_2015", "TX_5_T_2016", "TX_5_T_2017"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                }, {
                                    LAYER_ID: "ThematiqueProv_Reseau",
                                    FEATURES_IDS: ["RESEAU_PUBLIC"],
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_5_T_1998", "TX_5_T_1999", "TX_5_T_2000", "TX_5_T_2001", "TX_5_T_2002", "TX_5_T_2003", "TX_5_T_2004", "TX_5_T_2005", "TX_5_T_2006", "TX_5_T_2007", "TX_5_T_2008", "TX_5_T_2009", "TX_5_T_2010", "TX_5_T_2011", "TX_5_T_2012", "TX_5_T_2013", "TX_5_T_2014", "TX_5_T_2015", "TX_5_T_2016", "TX_5_T_2017"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                }
                            ]
                        }
                    ]
                }, {
                    BUTTON_TITLE: "Sexe masculin",
                    GRAPHS: [
                        {
                            TITLE: "Évolution des taux de diplomation et qualification par cohorte au secondaire après 5 ans, sexe masculin, cohortes de 1998 à 2017",
                            DATA_NAMES: {"Réseau public": "Moyenne provinciale - sexe masculin"},
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "GEO09E06_REG_ADM_GEN",
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_5_M_1998", "TX_5_M_1999", "TX_5_M_2000", "TX_5_M_2001", "TX_5_M_2002", "TX_5_M_2003", "TX_5_M_2004", "TX_5_M_2005", "TX_5_M_2006", "TX_5_M_2007", "TX_5_M_2008", "TX_5_M_2009", "TX_5_M_2010", "TX_5_M_2011", "TX_5_M_2012", "TX_5_M_2013", "TX_5_M_2014", "TX_5_M_2015", "TX_5_M_2016", "TX_5_M_2017"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                }, {
                                    LAYER_ID: "ThematiqueProv_Reseau",
                                    FEATURES_IDS: ["RESEAU_PUBLIC"],
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_5_M_1998", "TX_5_M_1999", "TX_5_M_2000", "TX_5_M_2001", "TX_5_M_2002", "TX_5_M_2003", "TX_5_M_2004", "TX_5_M_2005", "TX_5_M_2006", "TX_5_M_2007", "TX_5_M_2008", "TX_5_M_2009", "TX_5_M_2010", "TX_5_M_2011", "TX_5_M_2012", "TX_5_M_2013", "TX_5_M_2014", "TX_5_M_2015", "TX_5_M_2016", "TX_5_M_2017"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                }
                           ]
                       }
                    ]
                }, {
                    BUTTON_TITLE: "Sexe féminin",
                    GRAPHS: [
                        {
                            TITLE: "Évolution des taux de diplomation et qualification par cohorte au secondaire après 5 ans, sexe féminin, cohortes de 1998 à 2017",
                            DATA_NAMES: {"Réseau public": "Moyenne provinciale - sexe féminin"},
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "GEO09E06_REG_ADM_GEN",
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_5_F_1998", "TX_5_F_1999", "TX_5_F_2000", "TX_5_F_2001", "TX_5_F_2002", "TX_5_F_2003", "TX_5_F_2004", "TX_5_F_2005", "TX_5_F_2006", "TX_5_F_2007", "TX_5_F_2008", "TX_5_F_2009", "TX_5_F_2010", "TX_5_F_2011", "TX_5_F_2012", "TX_5_F_2013", "TX_5_F_2014", "TX_5_F_2015", "TX_5_F_2016", "TX_5_F_2017"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                }, {
                                    LAYER_ID: "ThematiqueProv_Reseau",
                                    FEATURES_IDS: ["RESEAU_PUBLIC"],
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_5_F_1998", "TX_5_F_1999", "TX_5_F_2000", "TX_5_F_2001", "TX_5_F_2002", "TX_5_F_2003", "TX_5_F_2004", "TX_5_F_2005", "TX_5_F_2006", "TX_5_F_2007", "TX_5_F_2008", "TX_5_F_2009", "TX_5_F_2010", "TX_5_F_2011", "TX_5_F_2012", "TX_5_F_2013", "TX_5_F_2014", "TX_5_F_2015", "TX_5_F_2016", "TX_5_F_2017"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: false
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        RIGHT_PANEL: {
            DEFAULTS: {
                ACTIVE_LAYER_ID: "GEO09E06_REG_ADM_GEN",
                GRAPH_TYPE: "bar",
                GRAPH_DATA_ORIENTATION: "columns",
                PADDING: {"top": 0, "right": 15, "bottom": 20, "left": 30},
                HEIGHT_FN: function() { return 325;},
                WIDTH_FN: function() {
                    if (!DomUtil.isResponsiveUI()) return $(".cv-right-top-pane").width() - 30;
                    else return $("#cv-responsiveBbGraphsView").width() - 10;
                },
                STACK_ORDER: "asc",
                DATA_AUTO_SORT: "asc",
                X_AXIS_LABEL: {"text": "Reg. Adm.", "position": "outer-right"},
                X_AXIS_TICK_VALUES: [],
                Y_AXIS_LABEL: "pts. de %",
                DATA_COLORS: {"FGJ": "#a68adb", "FGA": "#85aec9", "FP": "#afbd54",  "Diplômes": "#6194BF", "Qualifications": "#B9EAD8"}
                //TOOLTIP_VALUE_FN: function(y, graph) { return y + " pts. de %";}
            },
            TABS: [
                {
                    BUTTON_TITLE: "Sexes réunis",
                    GRAPHS: [
                        {
                            TITLE: "Contribution de la FGJ, FGA et FP dans le taux après 5 ans de la cohorte de {{TEXT}}, sexes réunis",
                            X_DATA_NAMES: ["FGJ", "FGA", "FP"],
                            STACK_GROUPS: [["FGJ", "FGA", "FP"]],
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "GEO09E06_REG_ADM_GEN",
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_5_T_FGJ_{{VALUE}}", "TX_5_T_FGA_{{VALUE}}", "TX_5_T_FP_{{VALUE}}"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }, {
                            TITLE: "Contribution des diplômes et des qualifications dans le taux après 5 ans de la cohorte de {{TEXT}}, sexes réunis",
                            X_DATA_NAMES: ["Diplômes", "Qualifications"],
                            STACK_GROUPS: [["Diplômes", "Qualifications"]],
                            DATA_NAMES: ["Diplômes", "Qualifications"],
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "GEO09E06_REG_ADM_GEN",
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_5_T_DIPL_{{VALUE}}", "TX_5_T_QUAL_{{VALUE}}"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }
                    ]
                }, {
                    BUTTON_TITLE: "Sexe masculin",
                    GRAPHS: [
                        {
                            TITLE: "Contribution de la FGJ, FGA et FP dans le taux après 5 ans de la cohorte de {{TEXT}}, sexe masculin",
                            X_DATA_NAMES: ["FGJ", "FGA", "FP"],
                            STACK_GROUPS: [["FGJ", "FGA", "FP"]],
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "GEO09E06_REG_ADM_GEN",
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_5_M_FGJ_{{VALUE}}", "TX_5_M_FGA_{{VALUE}}", "TX_5_M_FP_{{VALUE}}"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }, {
                            TITLE: "Contribution des diplômes et des qualifications dans le taux après 5 ans de la cohorte de {{TEXT}}, sexe masculin",
                            X_DATA_NAMES: ["Diplômes", "Qualifications"],
                            STACK_GROUPS: [["Diplômes", "Qualifications"]],
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "GEO09E06_REG_ADM_GEN",
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_5_M_DIPL_{{VALUE}}", "TX_5_M_QUAL_{{VALUE}}"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }
                    ]
                }, {
                    BUTTON_TITLE: "Sexe féminin",
                    GRAPHS: [
                        {
                            TITLE: "Contribution de la FGJ, FGA et FP dans le taux après 5 ans de la cohorte de {{TEXT}}, sexe féminin",
                            X_DATA_NAMES: ["FGJ", "FGA", "FP"],
                            STACK_GROUPS: [["FGJ", "FGA", "FP"]],
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "GEO09E06_REG_ADM_GEN",
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_5_F_FGJ_{{VALUE}}", "TX_5_F_FGA_{{VALUE}}", "TX_5_F_FP_{{VALUE}}"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }, {
                            TITLE: "Contribution des diplômes et des qualifications dans le taux après 5 ans de la cohorte de {{TEXT}}, sexe féminin",
                            X_DATA_NAMES: ["Diplômes", "Qualifications"],
                            STACK_GROUPS: [["Diplômes", "Qualifications"]],
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "GEO09E06_REG_ADM_GEN",
                                    DATATABLE_ID: "t_frequentation",
                                    DATACOLUMNS_IDS: ["TX_5_F_DIPL_{{VALUE}}", "TX_5_F_QUAL_{{VALUE}}"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };
});
